export const POWER_POLICY_FIELD_KEYS = {
  powerPolicy: 'powerPolicy',
} as const;

export const POWER_POLICY_FIELD_KEY_LIST = [POWER_POLICY_FIELD_KEYS.powerPolicy] as const;
